import { Head } from '@zoopla/layout/head';
import { getNewHomesGoogleSchema } from '../../utils/getNewHomesGoogleSchema';
import { newHomesFaqContent } from '../NewHomesFaq';

export const NewHomesHead = () => (
    <Head
        pageTitle="New Homes for Sale | Buy New Build Houses and Flats - Zoopla"
        pageDescription="Search for and browse newly built property developments in the UK. Find a brand new house or flat using Zoopla's new homes search."
        canonicalPath="/new-homes/"
        schema={() => getNewHomesGoogleSchema(newHomesFaqContent)}
    />
);
